import axios, { AxiosInstance, AxiosResponse } from "axios";

export interface ITripPrices {
  minPrice: number,
  bargainPrice: number
}

export const apiClient: AxiosInstance = axios.create({
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

export async function fetchTripPrices(api: string, trip: number): Promise<ITripPrices|null> {
    try {
        const response: AxiosResponse = await apiClient.get(`${api}?trip=${trip}`);

        return response.data.response;
    } catch (e) {
        return null;
    }
}
